export default {"src":"/_next/static/media/intro.be827f25.svg","height":378,"width":492,"blurWidth":0,"blurHeight":0};